import GDP from "../../../../content/blog/data-visualization/gdp";
import * as React from 'react';
export default {
  GDP,
  React
};